import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IForgotPasswordGeneratePinEntity } from '../../../entity';

export interface IForgotPasswordGeneratePinByMsisdnUseCase {
    execute(msisdn: string): Promise<IForgotPasswordGeneratePinEntity>;
}

export class ForgotPasswordGeneratePinByMsisdnUseCase implements IForgotPasswordGeneratePinByMsisdnUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(msisdn: string): Promise<IForgotPasswordGeneratePinEntity> {
        return await this.userRepo.forgotPasswordGeneratePinByMsisdn(msisdn);
    }
}
